export const dailyGiftAssets = {
	main: {
		backgroundLogin: "/spec_daily_gift/background-login.png",
		backgroundLoginMobile: "/spec_daily_gift/background-login-mobile.png",
		titleLogin: "/spec_daily_gift/daily_login_streak_title_v4_large.png",
		titleLoginMobile: "/spec_daily_gift/daily_login_streak_title_v4_small.png"
	},
	streakDay: {
		check: "/spec_daily_gift/check.png",
		locked: "/spec_daily_gift/locked.png",
		starBurst: "/spec_daily_gift/star-burst.png"
	},
	popups: {
		streakBreak: {
			background: "/spec_daily_gift/background-daily-login-streak-break.png",
			backgroundMobile: "/spec_daily_gift/mobile-background.png",
			poi: "/spec_daily_gift/poi-daily-login-streak-break.png",
			poiMobile: "/spec_daily_gift/mobile-poi-daily-login-streak-break.png",
			title: "/spec_daily_gift/text-daily-login-streak-break.png",
			titleMobile: "/spec_daily_gift/mobile-text-daily-login-streak-break.png"
		},
		loyaltyPoints: "/spec_daily_gift/bg-loyalty-points_v2.png",
		earned: "/spec_daily_gift/bg-popup.png"
	}
} as const;
